var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"token"},[_c('v-img',{key:_vm.id,staticClass:"token-svg",attrs:{"src":_vm.src,"aspect-ratio":"1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }